// extracted by mini-css-extract-plugin
export var redoItem = "_ic-1";
export var redoTrigger = "_ic-0";